import VideoGridViewer from './VideoGridViewer';

export default VideoGridViewer;
